import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import API from "../services/api";

const DEFAULT = {
  app_name: "MomnKidzCare",
  tagline: "Women's health & family care",
  logo_url: null,
  logo_emoji: "❤"
};

const BrandingContext = createContext({
  branding: DEFAULT,
  loading: true,
  refresh: async () => {}
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await API.get("/branding");
      setBranding({ ...DEFAULT, ...data });
    } catch {
      setBranding(DEFAULT);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <BrandingContext.Provider value={{ branding, loading, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
